module.exports = __webpack_public_path__ + "static/media/info_banner.a2627b34.png";